import { render, staticRenderFns } from "./PazientiEdit.vue?vue&type=template&id=049f68f0"
import script from "./PazientiEdit.vue?vue&type=script&lang=js"
export * from "./PazientiEdit.vue?vue&type=script&lang=js"
import style0 from "./PazientiEdit.vue?vue&type=style&index=0&id=049f68f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports